import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { SonarText } from '@ui/text';

import { Checkbox, Form } from 'antd';

export const NewObjectAndFieldAccess: React.FC = () =>
	<FeatureBoundary feature={ FeatureFlag.AutomaticallyRevokeNewOAuthAccessTokens }>
		<SonarText className='subheading'>{ COPY_SPECIFIC.SECURITY }</SonarText>
		<Form.Item
			name={ [ 'monitorConfig', 'blockAppsWhenAccessChanges' ] }
			valuePropName='checked'>
			<Checkbox>{ COPY_SPECIFIC.BLOCK_APPLICATIONS_NEW_OBJECTS }</Checkbox>
		</Form.Item>
	</FeatureBoundary>;
